import React from 'react';
import { LOGO_BASE_URL } from '../../config';
import '../../styles/BusinessCard.css';

function BusinessCard({ business, onClick, isFavorite, onToggleFavorite }) {
  return (
    <article className="business-card-wrap">
      <button type="button" className="business-card" onClick={() => onClick(business.id)}>
        <div className="business-card-logo">
          <img
            src={`${LOGO_BASE_URL}/${business.id}`}
            alt=""
            onError={(e) => {
              e.target.style.display = 'none';
              const fb = e.target.nextElementSibling;
              if (fb) fb.classList.add('visible');
            }}
          />
          <span className="business-card-logo-fallback">{business.title?.charAt(0) || '?'}</span>
        </div>
        <div className="business-card-body">
          <h2 className="business-card-name">{business.title}</h2>
          <p className="business-card-location">{business.address || '—'}</p>
          {business.next_available?.display && (
            <p className="business-card-next-slot">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <span>أقرب موعد: {business.next_available.display}</span>
            </p>
          )}
          {(business.category_name_ar || business.category_name) && (
            <span className="business-card-category">
              {business.category_name_ar || business.category_name}
            </span>
          )}
        </div>
        <svg className="business-card-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {onToggleFavorite && (
        <button
          type="button"
          className={`business-card-favorite ${isFavorite ? 'active' : ''}`}
          onClick={(e) => onToggleFavorite(business.id, e)}
          aria-label={isFavorite ? 'إزالة من المفضلة' : 'إضافة للمفضلة'}
          title={isFavorite ? 'إزالة من المفضلة' : 'إضافة للمفضلة'}
        >
          <svg viewBox="0 0 24 24" fill={isFavorite ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
    </article>
  );
}

export default BusinessCard;
